export const PRODUCT_TYPE = {
  GOODS: "goods",
  TICKET: "ticket",
} as const;
